import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ManageFAQs() {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [faqs, setFaqs] = useState([]);
  const [editingFaq, setEditingFaq] = useState(null); // Track the FAQ being edited

  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getfaqs`); // Replace with your API endpoint
      setFaqs(response.data);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    }
  };

  const handleAddFaq = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/addfaq`, { question, answer }); // Replace with your API endpoint
      setQuestion('');
      setAnswer('');
      fetchFAQs();
    } catch (error) {
      console.error('Error adding FAQ:', error);
    }
  };

  const handleEditFaq = (faq) => {
    setEditingFaq(faq);
    setQuestion(faq.question);
    setAnswer(faq.answer);
  };

  const handleUpdateFaq = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/updatefaq/${editingFaq._id}`, { question, answer }); // Replace with your API endpoint
      setEditingFaq(null);
      setQuestion('');
      setAnswer('');
      fetchFAQs();
    } catch (error) {
      console.error('Error updating FAQ:', error);
    }
  };

  const handleDeleteFaq = async (id) => {
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/deletefaq/${id}`); // Replace with your API endpoint
      fetchFAQs();
    } catch (error) {
      console.error('Error deleting FAQ:', error);
    }
  };

  return (
    <div className="p-8 bg-white rounded-lg shadow-md max-w-2xl mx-auto">
      <h2 className="text-3xl font-semibold text-gray-800 mb-6">Manage FAQs</h2>

      {/* Add FAQ Section */}
      <div className="mb-8 border p-4 rounded-md">
        <h3 className="text-xl font-semibold mb-4">Add FAQ</h3>
        <form onSubmit={editingFaq ? handleUpdateFaq : handleAddFaq} className="space-y-4">
          <div>
            <label htmlFor="question" className="block text-sm font-medium text-gray-700">Question</label>
            <input
              type="text"
              id="question"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
            />
          </div>
          <div>
            <label htmlFor="answer" className="block text-sm font-medium text-gray-700">Answer</label>
            <textarea
              id="answer"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
            />
          </div>
          <button
            type="submit"
            className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded-md"
          >
            {editingFaq ? 'Update FAQ' : 'Add FAQ'}
          </button>
          {editingFaq && (
            <button
              type="button"
              className="bg-gray-300 hover:bg-gray-400 py-2 px-4 rounded-md ml-2"
              onClick={() => {
                setEditingFaq(null);
                setQuestion('');
                setAnswer('');
              }}
            >
              Cancel Edit
            </button>
          )}
        </form>
      </div>

      {/* Edit FAQs Section */}
      <div>
        <h3 className="text-xl font-semibold mb-4">Edit FAQs</h3>
        <div className="space-y-4">
          {faqs.map((faq) => (
            <div key={faq._id} className="border p-4 rounded-md flex justify-between gap-2 items-center">
              <div className='w-full'>
                <p className="font-semibold">{faq.question}</p>
                <p>{faq.answer}</p>
              </div>
              <div className="w-fit flex flex-col">
                <button
                  onClick={() => handleEditFaq(faq)}
                  className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md w-full"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDeleteFaq(faq._id)}
                  className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-md w-full"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ManageFAQs;